import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HomeEvent, HomeNotification, HomeSale, HomeTicket, HomeUsers } from 'src/models/home';

interface UserHomeState {
    isLoading: boolean;
    isLoadingEvent: boolean;
    isLoadingSale: boolean;
    isLoadingTickets: boolean;
    isLoadingNotifications: boolean;
    isLoadingUsers: boolean;
    isErrorMessage: string;
    statusCode: number;
    userHome: [] | null | {};
    changeUserHome: null;
    homeEvents: HomeEvent[];
    homeSale: HomeSale | null,
    homeTicket: HomeTicket[],
    homeNotification: HomeNotification[],
    homeRegisteredUser: HomeUsers [];
};
  
const initialState: UserHomeState = {
    isLoading: false,
    isLoadingEvent: false,
    isLoadingSale: false,
    isLoadingTickets: false,
    isLoadingNotifications: false,
    isLoadingUsers: false,
    statusCode: 201,
    isErrorMessage: '',
    userHome: [],
    changeUserHome: null,
    homeEvents: [],
    homeSale: null,
    homeTicket: [],
    homeNotification: [],
    homeRegisteredUser:[],
};

export const UserHomeSlice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        toggleLoading: (state, action: PayloadAction<{
            key: Extract<keyof UserHomeState,
                'isLoading' | 'isLoadingEvent' | 'isLoadingSale' | 'isLoadingTickets' | 'isLoadingNotifications' | 'isLoadingUsers'
            >;
            value: boolean
        }>) => {
            state[action.payload.key] = action.payload.value;
        },          
        setUserHome: (state, action) => {
            state.isLoading = false;
            state.userHome = [...action.payload];
        },
        setChangeUserHome: (state, action) => {
            state.changeUserHome = action.payload;
        },
        setError: (state, action) => {
            const message = action.payload.message;
            state.statusCode = action.payload.status;
            state.isErrorMessage = message;
        },
        setHomeEvent: (state, action) => {
            state.isLoading = false;
            state.homeEvents = [...action.payload];
        },
        setHomeSale: (state, action) => {
            state.isLoading = false;
            state.homeSale = action.payload;
        },
        setHomeTicket: (state, action) => {
            state.isLoading = false;
            state.homeTicket = [...action.payload];
        },
        setHomeNotification: (state, action) => {
            state.isLoading = false;
            state.homeNotification = [...action.payload];
        },
        setHomeRegisteredUser: (state, action) => {
            state.isLoading = false;
            state.homeRegisteredUser = action.payload;
        },
        // Limpiar todos los datos del Home (usado al cambiar de productora)
        clearHomeData: (state) => {
            state.homeEvents = [];
            state.homeSale = null;
            state.homeTicket = [];
            state.homeNotification = [];
            state.homeRegisteredUser = [];
        },
    }
});

export const {
    toggleLoading,
    setUserHome,
    setHomeEvent,
    setHomeSale,
    setHomeTicket,
    setHomeNotification,
    setChangeUserHome,
    setError,
    setHomeRegisteredUser,
    clearHomeData
} = UserHomeSlice.actions;